import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { createLocalBillCategory } from '../../../../../../../../../../crud/management_api/local_bill_category';

interface CreateCategoryBillProps {
  show: boolean;
  handleClose: () => void;
  handleAddCategory: (newCategory: { local_bill_category_id: number; category_name: string; }) => void;
}

const CreateCategoryBill: React.FC<CreateCategoryBillProps> = ({
  show,
  handleClose,
  handleAddCategory,
}) => {
  // Estados para categoría
  const [categoryName, setCategoryName] = useState('');
  const [categoryDescription, setCategoryDescription] = useState('');

  // Obtener local_id desde localStorage
  const localId = (() => {
    const user = JSON.parse(localStorage.getItem('user') ?? '{}');
    return user.local_id || null;
  })();

  // Validaciones
  const isCategoryValid = categoryName.trim() !== '' && localId;

  // Función para manejar la creación de categoría
  const handleSaveCategory = async () => {
    if (!isCategoryValid) {
      alert('Por favor, completa todos los campos requeridos.');
      return;
    }

    // Crear el payload según el modelo
    const payload = {
      local_bill_category_id: null, // Este campo es opcional si el backend lo genera automáticamente
      category_name: categoryName,
      category_description: categoryDescription,
      local_id: localId,
    };

    try {
      const response = await createLocalBillCategory(payload);
      console.log('Categoría creada:', response.data);

      // Llamar al callback para agregar la categoría localmente
      handleAddCategory({
        local_bill_category_id: response.data.local_bill_category_id,
        category_name: response.data.category_name,
      });

      // Limpiar campos y cerrar modal
      setCategoryName('');
      setCategoryDescription('');
      handleClose();
    } catch (error) {
      console.error('Error al crear categoría:', error);
      alert('Hubo un error al crear la categoría.');
    }
  };

  // Limpiar los campos cuando el modal se cierre
  useEffect(() => {
    if (!show) {
      setCategoryName('');
      setCategoryDescription('');
    }
  }, [show]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Crear Cuenta</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        {/* Formulario para crear categoría */}
        <Form>
          <Form.Group className="mp-formgroup horizontal" controlId="categoryName">
            <Form.Label>Nombre de la Cuenta</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ingrese el nombre"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mp-formgroup vertical" controlId="categoryDescription">
            <Form.Label>Descripción</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ingrese una descripción"
              value={categoryDescription}
              onChange={(e) => setCategoryDescription(e.target.value)}
              required
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="none" className="form-button-cancel" onClick={handleClose}>
          Cerrar
        </Button>
        <Button
          variant="none"
          className="form-button-create"
          onClick={handleSaveCategory}
          disabled={!isCategoryValid}
        >
          Guardar Cuenta
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateCategoryBill;
